<div class="incoming-call-container">
  <div class="call-info">
    <div class="caller-avatar">
      <i class="material-icons">person</i>
    </div>
    <div class="caller-details">
      <p class="call-subtitle">Đang gọi đi...</p>
      <p class="caller-number" *ngIf="callingPhoneNumber$ | async as number">
        {{ number }}
      </p>
      <h3 class="caller-name" *ngIf="callingPhoneName$ | async as name">
        {{ name }}
      </h3>
      <p class="call-type" *ngIf="isVideoCall$ | async as isVideo">
        {{ isVideo ? 'Cuộc gọi video' : 'Cuộc gọi thoại' }}
      </p>
    </div>
  </div>

  <div class="call-actions">
    <button class="action-btn" (click)="openTicket()" title="Xem phiếu" *ngIf="crm_url">
      <i class="material-icons">confirmation_number</i>
    </button>
    <button class="action-btn reject-btn" (click)="hangupCall()" title="Kết thúc">
      <i class="material-icons">call_end</i>
    </button>
  </div>
</div>